import PropTypes from 'prop-types';
import { useEffect } from 'react';
// @mui
import Stack from '@mui/material/Stack';
// hooks
import { useScrollSpy } from 'src/hooks/use-scroll-spy';
// routes
import { usePathname } from 'src/routes/hooks';
//
import { HOME_SECTION_IDS } from '../../config-navigation';
import NavList from './nav-list';

// ----------------------------------------------------------------------

export default function NavDesktop({ offsetTop, data }) {
  const pathname = usePathname();

  // Only spy on the home page to avoid corrupting the URL on marketing or
  // other pages that reuse the same section IDs.
  const activeSection = useScrollSpy(HOME_SECTION_IDS, { enabled: pathname === '/' });

  useEffect(() => {
    if (activeSection) {
      window.history.replaceState(window.history.state, '', `/#${activeSection}`);
    }
  }, [activeSection]);

  return (
    <Stack component="nav" direction="row" spacing={5} sx={{ mr: 2.5, height: 1 }}>
      {data.map((link) => (
        <NavList key={link.title} item={link} offsetTop={offsetTop} activeSection={activeSection} />
      ))}
    </Stack>
  );
}

NavDesktop.propTypes = {
  data: PropTypes.array,
  offsetTop: PropTypes.bool,
};
